import { Injectable } from '@angular/core';
import { StorageService } from '../../../services/storage.service';
import { CartsByLegalEntity } from '../../../models/cartsByLegalEntity.model';

@Injectable()
export class SharedEffectsService {
    constructor(private storageService: StorageService) { }

    makeActiveCartAsFirst(data: CartsByLegalEntity): CartsByLegalEntity {
        if (data?.carts?.length > 0) {
            const legalEntityId = this.storageService.defaultLegalEntity?.uid;
            const index = data.carts.findIndex(
                (cartObj) =>
                    cartObj['legalEntity']?.uid === legalEntityId &&
                    cartObj['isActiveCart'] === true
            );
            if (index !== -1) {
                const cartObj = data.carts[index];
                data.carts = data.carts.filter((v, i) => i !== index);
                data.carts = [cartObj, ...data.carts];
            }
        }
        return data;
    }
}
